import {
  minLength, maxLength, required, email,
} from 'vuelidate/lib/validators';
import { isValidString } from '../../validation/validationMethods';


export default {
  user: {
    givenName: {
      minLength: minLength(1),
      maxLength: maxLength(255),
      required,
      isValidString,
    },
    familyName: {
      minLength: minLength(1),
      maxLength: maxLength(255),
      required,
      isValidString,
    },
    role: {
      minLength: minLength(1),
      required,
      isValidString,
    },
    email: {
      minLength: minLength(1),
      required,
      email,
    },
  },
};
